import React from 'react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <section className="w-full py-12" style={{
    backgroundColor: 'var(--color-cream)'
  }} data-id="element-82">
      <div className="max-w-3xl mx-auto px-4" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col md:flex-row items-center gap-8 bg-white p-6 md:p-8 rounded-2xl shadow-sm border" style={{
        borderColor: 'var(--color-border)'
      }} data-id="element-84">
          <div className="w-full md:w-1/2 rounded-xl overflow-hidden" data-id="element-85">
            <img src="https://cdn.magicpatterns.com/uploads/umXHXkRpZ6o5HCKnNs98rv/DSC09939-2.jpg" alt="Hunderunde Verpackung + Oscar Foto" className="w-full h-auto object-cover" data-id="element-86" />
          </div>
          <div className="w-full md:w-1/2 space-y-4" data-id="element-87">
            <h3 className="font-handwritten text-3xl" style={{
            color: 'var(--color-green)'
          }} data-id="element-88">
              Was ich bestellt habe
            </h3>
            <p className="text-base leading-relaxed" style={{
            color: 'var(--color-text)'
          }} data-id="element-89">
              Ich habe mich für das Magen & Darm Futtertopping von Hunderunde
              entschieden, weil es zu 100% aus natürlichen Kräutern und
              Präbiotika besteht. Es ist keine chemische Keule, sondern
              unterstützt Oscars Verdauung auf sanfte Weise genau dort, wo das
              Problem liegt.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}